<div class="menu">
  <div class="content-box">
    <div
      (click)="closeModal()"
      class="svg-container"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="47.164" height="47.436" viewBox="0 0 47.164 47.436">
        <defs>
          <style>.a-close-page{fill:#ffa700;}</style>
        </defs>
        <path class="a-close-page" d="M-1054.646-205.092l9.214,9.979-13.606,13.735,13.7,13.909-9.671,9.5-13.834-13.628-14.023,13.941-9.575-9.651c4.61-4.673,9.15-9.277,13.858-14.052l-13.92-14.086,9.633-9.6,14.043,13.921Z" transform="translate(1092.5 205.092)"/>
      </svg>
    </div>
    <div class="login-txt">
      <div class="manual-div">
        <p>Are you sure you want to exit?</p>
        <button
          type="button"
          (click)="proceedToLogout()"
        >
          Exit
        </button>
      </div>
    </div>
  </div>
</div>
